import React, { useContext, useEffect, useState } from 'react'
import {auth} from '../firebaseConfig'
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail,
   signOut, updatePassword, updateEmail } from "firebase/auth";
import { getDefaultNormalizer } from '@testing-library/react';


const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider ({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true)
  const [admin, setAdmin] = useState(false);

  function signup (email, password) {
    try {
      const user = createUserWithEmailAndPassword (auth, email, password);
      console.log (user.email);
      return user;
    // .then((userCredential) => {
    //   // Signed in 
    //   const user = userCredential.user;
    //   console.log (userCredential);
    //   // ...
    // })
    // .catch((error) => {
    //   console.log (error);
    //   const errorCode = error.code;
    //   const errorMessage = error.message;
    //   console.log (errorCode + " " + errorMessage)
    //   // ..
    // });
  
    } catch (e) {console.log (e.message)}
  }

  function login (email, password) {
    try {
      // return signInWithEmailAndPassword (auth, email, password)
      return signInWithEmailAndPassword (auth, email, password)
    } catch (e) {console.log (e)}
  }

  async function logout () {
    try {
      // return signInWithEmailAndPassword (auth, email, password)
      const stat = await signOut (auth);
      setAdmin (false);
      return stat;

    } catch (e) {console.log (e)}
  }
  
  function resetPassword (email) {
    return sendPasswordResetEmail (auth,email);
  }

  function updateEmail_ (email) {
    return updateEmail(currentUser, email);
  }

  function updatePass (password) {
    return updatePassword(currentUser, password);
  }

  // onAuthStateChanged(auth, (user) => {
  auth.onAuthStateChanged(user => {
    setCurrentUser(user);
    if (user) {
      // User is signed in, see docs for a list of available properties
      // https://firebase.google.com/docs/reference/js/firebase.User
      const uid = user.uid;
      // ...
    } else {
      // User is signed out
      // ...
    }
  });

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
      if (user) {
        if (user.email === process.env.REACT_APP_eli 
        || user.email === process.env.REACT_APP_j321 
        || user.email === process.env.REACT_APP_DAN
        || user.email === process.env.REACT_APP_MICHA
        || user.email === process.env.REACT_APP_MOSHE
        ) {
          setAdmin(true)
          console.log ('logged email:', user.email, ' (admin)', ) 
        }
        else {
          setAdmin(false)
          console.log('logged email:', user.email);
        }
      }
      setLoading(false)
    })
    return unsubscribe;
  }, [currentUser]);


  const value = {
    currentUser,
    admin,
    signup,
    login,
    logout,
    resetPassword,
    updateEmail_,
    updatePass
  }
  return (
    <AuthContext.Provider value={value}>
      { ! loading && children }

    </AuthContext.Provider>
  )
}
